import React from 'react';
import { DropdownButton, Dropdown } from 'react-bootstrap';

import { learnersAnalyticsActions } from 'pages/insights/containers/learnersAnalyticsContainer/actions';
import { messageNotification } from 'helpers';

const moment = require('moment');

const DownloadLearnersAnalytics = (props) => {
  const { dispatch } = props;

  const handleFilterChange = (value) => {
    if (value === 'pdf') {
      dispatch(learnersAnalyticsActions.downloadLearnersDetailsPDF());
    } else if (value === 'csv') {
      dispatch(
        learnersAnalyticsActions.fetchLearnersSummaryCSV({
          filter_roles: 'learner',
          filter_start_date: moment()
            .startOf('month')
            .format('DD-MM-YYYY'),
          filter_end_date: moment()
            .endOf('month')
            .format('DD-MM-YYYY')
        })
      );
    }

    if (value === 'pdf') {
      messageNotification('success', 'Learners Analytics Export', 'Learners Analytics Report will be emailed soon.');
    } else if (value === 'csv') {
      messageNotification('success', 'Learners Analytics Export', 'Learners Analytics Data Export In Progress');
    }
  };

  return (
    <div id="learner_download_dropdowns">
      <DropdownButton variant="outline-primary" title={'Export Report'}>
        <Dropdown.Item onClick={() => handleFilterChange('pdf')}>Email PDF</Dropdown.Item>
        <Dropdown.Item onClick={() => handleFilterChange('csv')}>Email CSV</Dropdown.Item>
      </DropdownButton>
    </div>
  );
};

export default DownloadLearnersAnalytics;
